import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LanguageState } from './types';

const initialState: LanguageState = {
  currentLanguage: 'en',
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.currentLanguage = action.payload;
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export const selectLanguage = (state: any) => {
    const slice = state.get ? state.get('language') : state.language;
    return slice ? slice.currentLanguage : 'en';
};

export default languageSlice.reducer;